import { writable } from 'svelte/store';
export const constraintsWritable = writable({
    areaMin: 0,
    areaMax: 250,
    areaStep: 1,
    roomsMin: 1,
    roomsMax: 5,
    roomsStep: 1,
    floorMin: 0,
    floorMax: 5,
    floorStep: 1,
    priceMin: 0,
    priceMax: 1000000,
    priceStep: 1,
    floors: [0, 1, 2, 3, 4, 5],
    rooms: [1, 2, 3, 4, 5],
    directions: ['n', 'e', 's', 'w'],
    additionalAreas: ['balcony', 'garden', 'terrace'],
    areas: [],
    traits: [],
    features: []
});
